<template>
  <div class="accommodation-params">
    <el-row>
      <el-col :span="24">
        批次編號規則:
        <el-select size="small" v-model="arr" multiple style="width: 600px">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="24">
        批次編號規則:
        <template v-for="i in arr">
          <el-input
            :key="i"
            size="small"
            v-model="value[i]"
            :placeholder="label[i]"
            :disabled="disabled[i]"
            style="width: 200px"
          ></el-input>
        </template>
      </el-col>
      <el-col :span="24">
        批次編號分隔符:
        <el-select size="small" v-model="childrenData.BatchNoRuleSplitChar">
          <el-option
            v-for="item in optionChars"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="12">
        內部備註:
        <el-input
          type="textarea"
          size="small"
          :autosize="{ minRows: 4, maxRows: 6 }"
          v-model="childrenData.InternalRemark"
        ></el-input>
      </el-col>
      <el-col :span="12">
        外部備註:
        <el-input
          type="textarea"
          size="small"
          :autosize="{ minRows: 4, maxRows: 6 }"
          v-model="childrenData.ExternalRemark"
        ></el-input>
      </el-col>
      <el-col :span="12">
        繳費日期開始時間:
        <el-date-picker
          type="date"
          size="small"
          value-format="yyyy-MM-dd"
          :placeholder="$t('app.validation.date')"
          v-model="childrenData.StartDate"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="12">
        繳費日期結束時間:
        <el-date-picker
          size="small"
          v-model="childrenData.EndDate"
          type="datetime"
          value-format="yyyy-MM-dd hh:mm:ss"
          :placeholder="$t('app.validation.date')"
          default-time="23:59:59"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="12">
        繳費DEADLINE日期:
        <el-date-picker
          size="small"
          v-model="childrenData.HostelDeadlineDate"
          type="datetime"
          value-format="yyyy-MM-dd hh:mm:ss"
          :placeholder="$t('app.validation.date')"
          default-time="23:59:59"
        >
        </el-date-picker>
      </el-col>
    </el-row>
    <span class="btn">
      <el-button size="small" type="warning" @click="reset">{{
        $t("app.reset")
      }}</el-button>
    </span>
  </div>
</template>
<script>
export default {
  props: {
    childrenData: {
      type: Object,
      default() {
        return {
          BatchNoRule: "",
          BatchNoRuleSplitChar: "",
          InternalRemark: "",
          ExternalRemark: "",
          StartDate: "",
          EndDate: "",
          HostelDeadlineDate: "",
          BatchNoRuleDetail: [],
        };
      },
    },
  },
  data() {
    return {
      value: {
        1: "",
        2: "",
        3: "",
        4: "",
      },
      options: [
        { value: "1", label: "任意字符" },
        { value: "2", label: "年份" },
        { value: "3", label: "學期" },
        { value: "4", label: "N位數字，N大於0" },
      ],
      label: {
        1: "任意字符",
        2: "年份",
        3: "學期",
        4: "N位數字，N大於0",
      },
      disabled: {
        1: false,
        2: true,
        3: true,
        4: false,
      },
      optionChars: [
        { value: "_", lable: "_" },
        { value: "-", lable: "-" },
      ],
    };
  },
  computed: {
    arr: {
      get() {
        return this.childrenData.BatchNoRule.split(",").filter((i) => i !== "");
      },
      set(val) {
        this.childrenData.BatchNoRule = val.join(",");
      },
    },
    text() {
      return this.arr.map((_) => this.value[_] || "").join("@******@");
    },
  },
  watch: {
    text(val) {
      this.childrenData.BatchNoRuleDetail = val.split("@******@");
    },
  },
  methods: {
    init(val) {
      this.arr.forEach((i, index) => {
        this.value[i] = val[index];
      });
    },
    reset() {
      this.childrenData.BatchNoRule = "";
      this.childrenData.BatchNoRuleSplitChar = "";
      this.childrenData.InternalRemark = "";
      this.childrenData.ExternalRemark = "";
      this.childrenData.StartDate = "";
      this.childrenData.EndDate = "";
      this.childrenData.HostelDeadlineDate = "";
      this.childrenData.BatchNoRuleDetail = [];
    },
  },
};
</script>
<style lang="scss" scoped>
.accommodation-params {
  min-height: 200px;
  padding-bottom: 50px;
  .el-row {
    .el-col {
      margin-bottom: 15px;
    }
  }
  .btn {
    position: absolute;
    bottom: 10px;
    right: 10px;
  }
}
</style>
